import { buildApiUrl } from '../config';
import { getAccessToken } from '../accountAuth';

export interface AccountCode {
  handle: string;
  message: string;
  updatedAt: string;
  viewCount: number;
  linkedAt: string;
  linkedVia: string;
}

export interface AccountMeResponse {
  userId: string;
  email: string;
  emailVerified: boolean;
  codes: AccountCode[];
}

export interface ClaimHandleResponse {
  handle: string;
  linkedAt: string;
  linkedVia: string;
}

const authHeaders = async (): Promise<Record<string, string>> => {
  const token = await getAccessToken();
  if (!token) throw new Error('Not authenticated');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

export const getMyAccount = async (): Promise<AccountMeResponse> => {
  const headers = await authHeaders();
  const response = await fetch(buildApiUrl('/account/me'), { headers });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
  return response.json();
};

export const deleteMyCode = async (handle: string): Promise<void> => {
  const headers = await authHeaders();
  const response = await fetch(buildApiUrl(`/account/code/${handle}`), {
    method: 'DELETE',
    headers,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
};

export const claimHandle = async (
  handle: string,
  handlePassword: string
): Promise<ClaimHandleResponse> => {
  const headers = await authHeaders();
  const response = await fetch(buildApiUrl('/account/claim-handle'), {
    method: 'POST',
    headers,
    body: JSON.stringify({ handle, handlePassword }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
  return response.json();
};
